import {
  addDays,
  startOfDay,
  subYears,
  endOfDay,
  addMonths,
} from '@qover/utils/src/date';
import {
  createValidator,
  dependsOn,
  email,
  isTrue,
  maxCurrency,
  maxDate,
  minCurrency,
  minDate,
  pattern,
  required,
} from '@qover/utils/src/validation';
import { EntityType } from '@qover-private/protos-web/qover/dojo/contracts/v1/policyholder';
import { Country } from '@qover/domain';

export const policyholderValidation = createValidator({
  'policyholder.address.street': [required],
  'policyholder.address.number': [required],
  'policyholder.address.zip': [
    required,
    dependsOn(
      'refs.country',
      'GB',
      pattern(/[A-Z]{1,2}[0-9R][0-9A-Z]?(\s)?[0-9][ABD-HJLNP-UW-Z]{2}/),
    ),
  ],
  'policyholder.address.city': [required],
  'policyholder.phone': [required],
  'policyholder.email': [required, email],
  'policyholder.title': [required],
  'policyholder.firstName': [required],
  'policyholder.lastName': [required],
  'policyholder.birthdate': [
    dependsOn(
      'policyholder.entityType',
      EntityType.ENTITY_TYPE_PERSON,
      required,
    ),
    dependsOn(
      'policyholder.entityType',
      EntityType.ENTITY_TYPE_PERSON,
      maxDate(subYears(new Date(), 18)),
    ),
  ],
  'policyholder.vatIn': [
    dependsOn(
      'policyholder.entityType',
      EntityType.ENTITY_TYPE_COMPANY,
      required,
    ),
  ],
  'policyholder.companyName': [
    dependsOn(
      'policyholder.entityType',
      EntityType.ENTITY_TYPE_COMPANY,
      required,
    ),
  ],
  'policyholder.billingAddress.street': [
    dependsOn(
      'policyholder.entityType',
      EntityType.ENTITY_TYPE_COMPANY,
      dependsOn('policyholder.billingAddressSameAsCompany', false, required),
    ),
  ],
  'policyholder.billingAddress.number': [
    dependsOn(
      'policyholder.entityType',
      EntityType.ENTITY_TYPE_COMPANY,
      dependsOn('policyholder.billingAddressSameAsCompany', false, required),
    ),
  ],
  'policyholder.billingAddress.zip': [
    dependsOn(
      'policyholder.entityType',
      EntityType.ENTITY_TYPE_COMPANY,
      dependsOn('policyholder.billingAddressSameAsCompany', false, required),
    ),
    dependsOn(
      'policyholder.entityType',
      EntityType.ENTITY_TYPE_COMPANY,
      dependsOn(
        'refs.country',
        'GB',
        pattern(/[A-Z]{1,2}[0-9R][0-9A-Z]?(\s)?[0-9][ABD-HJLNP-UW-Z]{2}/),
      ),
    ),
  ],
  'policyholder.billingAddress.city': [
    dependsOn(
      'policyholder.entityType',
      EntityType.ENTITY_TYPE_COMPANY,
      dependsOn('policyholder.billingAddressSameAsCompany', false, required),
    ),
  ],
});

export const quoteValidation = createValidator({
  'risk.type': [required],
  'risk.originalValue': [required, minCurrency(25000), maxCurrency(1000000)],
});

export const bikeValidation = createValidator({
  'risk.make': [required],
  'risk.model': [required],
});

export const bikeConditionValidation = createValidator({
  'risk.newBike': [required],
  'risk.bikePurchaseDate': [
    required,
    minDate(startOfDay(subYears(new Date(), 1))),
    maxDate(endOfDay(new Date())),
  ],
});

export const finalizationValidation = createValidator({
  startDate: [
    required,
    minDate(startOfDay(addDays(new Date(), 1))),
    maxDate(endOfDay(addMonths(new Date(), 6))),
  ],
});

export const summaryValidation = createValidator({
  clientAgreement: [required, isTrue],
  clientAgreement2: [dependsOn('refs.country', 'NL', required)],
});

export const missingDataValidation = (country?: Country) =>
  createValidator({
    ...(country === 'NL'
      ? {
          'uwQuestions.question1': [required],
          'uwQuestions.question2': [required],
          'uwQuestions.question3': [required],
        }
      : undefined),
  });
